import {
  Table as BaseTable,
  TableOptions as BaseTableOptions,
} from '@tiptap/extension-table'
import { TableView } from './TableView'

export type TableOptions = BaseTableOptions & {
  resizeParentSelector: string
}

export const Table = BaseTable.extend<TableOptions>({
  addKeyboardShortcuts() {
    return {
      ...this.parent?.(),
      'Mod-Alt-t': () =>
        this.editor.chain().focus().insertTable({ rows: 2, cols: 2 }).run(),
      'Mod-Shift-ArrowLeft': () => this.editor.commands.addColumnBefore(),
      'Mod-Shift-ArrowRight': () => this.editor.commands.addColumnAfter(),
      'Mod-Shift-ArrowUp': () =>
        this.editor.isActive('tableHeader')
          ? true // Prevents adding a row above when in table header
          : this.editor.commands.addRowBefore(),
      'Mod-Shift-ArrowDown': () => this.editor.commands.addRowAfter(),
      'Ctrl-Alt-Backspace': () => this.editor.commands.deleteColumn(),
      'Mod-Alt-Backspace': () => this.editor.commands.deleteRow(),
      'Shift-Alt-Backspace': () => this.editor.commands.deleteTable(),
    }
  },

  addOptions() {
    return {
      HTMLAttributes: {},
      renderWrapper: false,
      resizable: false,
      handleWidth: 5,
      cellMinWidth: 25,
      lastColumnResizable: true,
      allowTableNodeSelection: false,

      // NOTE: `...this.parent?.()` is here so
      // the defaults above can be overridden.
      ...this.parent?.(),
      View: null,
      resizeParentSelector: '.texteditor-content-wrapper',
    }
  },

  addNodeView() {
    const { cellMinWidth, resizeParentSelector } = this.options
    return ({ node, view }) => {
      return new TableView(node, view, cellMinWidth, resizeParentSelector)
    }
  },
})
